module.exports = __webpack_public_path__ + "geoCompassInverted_dark.cab075e9d1f591c7768eeeb9c6db8a34.png";